import ApiDocs from 'docs/src/modules/components/ApiDocs';
import api from 'docs/pages/x/api/data-grid/grid-row-grouping-api.json';

export default function RowGroupingApiNoSnap() {
  return <ApiDocs premiumApi={api} />;
}
